import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            token: localStorage.getItem("Golden_App_Token"),
            usertype: localStorage.getItem("Golden_App_User_Type"),
            user_id: localStorage.getItem("Golden_App_User_Id"),
            userImage: localStorage.getItem("Golden_App_userImg"),
            userPhone: localStorage.getItem("Golden_App_userPhone"),
            userName: localStorage.getItem("Golden_App_userPhone"),
            fullName: localStorage.getItem("Golden_App_fullName"),
            userCode: localStorage.getItem("Golden_App_userCode"),
        };
    },
    mutations,
    actions,
    getters,
};